import { useSettings } from '../slices/settings'
import { withAnimateValue } from './AnimateValue'
import { distance } from '../utils'

export const Distance = (props) => {
  const { value } = props
  const { unit } = useSettings()
  const [length, suffix] = distance(value, unit)

  if (length == undefined) return null
  if (length < 0) return '--'
  return `${length} ${suffix}`
}

export default withAnimateValue(Distance, 500)
